// TODO: deprecate in favor of usePathanalytics
class PathAnalyticsStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    // A store for handling path analytics

    this.prototype.actions = {
      setAnalytics(data) {
        if (data) {
          const { path, items } = data
          return this._mutate({ path_analytics: path, item_analytics: items })
        } else {
          this._mutate({ path_analytics: {}, item_analytics: {} })
        }
      }
    }

    this.prototype.requests = {
      getAnalyticsForItem(sourceID) {
        return __guard__(this.get("item_analytics"), (x) => x[sourceID]) || null
      }
    }
  }

  defaults() {
    return {
      subscriptions: {},
      path_analytics: {},
      item_analytics: {}
    }
  }
}
PathAnalyticsStore.initClass()

export default window.App.stores.registerStore(
  "pathAnalytics",
  PathAnalyticsStore
)
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
